import type { VoidFunctionComponent } from 'react';

import { FeatureFlagRequired } from '../../../generic';
import { ENABLE_REACHABILITY } from '../../../../../shared/featureFlags/flagNames';
import IssueDetailsReachability from '.';

/**
 * Gate for hiding the drawer tab contents for Reachability behind the
 * ENABLE_REACHABILITY feature flag.
 */
const IssueDetailsReachabilityGate: VoidFunctionComponent = () => {
  return (
    <FeatureFlagRequired flagName={ENABLE_REACHABILITY}>
      <IssueDetailsReachability />
    </FeatureFlagRequired>
  );
};

export default IssueDetailsReachabilityGate;
